import companyBrand from '../api/index'

const Commit = (query) => {
    return new Promise((resolve) => {
        resolve(companyBrand.companyBrand.Commit(query))
    })
}

export default {
    namespaced: true,
    state: {
        companyBrands: null,
    },
    getters: {
        GET_COMPANY_BRANDS(state) {
            return state.companyBrands;
        },
    },
    mutations: {
        SET_COMPANY_BRANDS(state, payload) {
            state.companyBrands = payload;
        },
    },
    actions: {
        async COMMIT_FROM_API({ commit }, payload) {
            await Commit(payload).then(
                ({
                    data, status
                }) => {
                    if (status === 200) {
                        if(data.succeeded)                        
                            commit('SET_COMPANY_BRANDS', data);                   
                    }
                }
            )
            .catch(() => {
                commit('SET_COMPANY_BRANDS', { succeeded: false });
            })
        },
    }
}
